import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import { useEmployeeStatusOptions } from "Hooks/Options/useEmployeeStatusOptions";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  name: FieldPath<FormType>;
  control: Control<FormType, unknown, TransformedFieldValues>;
  label?: string;
  disabled?: boolean;
};

export const EmployeeStatusDropdown = <T extends object, V extends object>({
  control,
  name,
  label,
  disabled,
}: Props<T, V>) => {
  const codeList = useEmployeeStatusOptions();

  return (
    <Dropdown
      codeList={codeList}
      name={name}
      control={control}
      label={label}
      disabled={disabled}
    />
  );
};
